/* Ultratooth — site behaviour: nav, scroll state, reveal-on-scroll */
(function () {
  "use strict";

  /* ---------------------------------------------------------- mobile nav */
  var toggle = document.querySelector(".nav-toggle");
  var links = document.getElementById("nav-links");

  if (toggle && links) {
    toggle.addEventListener("click", function () {
      var open = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!open));
      links.classList.toggle("open", !open);
    });

    // close on nav click (anchor links on the same page)
    links.addEventListener("click", function (e) {
      if (e.target.closest("a")) {
        toggle.setAttribute("aria-expanded", "false");
        links.classList.remove("open");
      }
    });

    // close on escape / resize back to desktop
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && links.classList.contains("open")) {
        toggle.setAttribute("aria-expanded", "false");
        links.classList.remove("open");
        toggle.focus();
      }
    });
    window.addEventListener("resize", function () {
      if (window.innerWidth > 900) {
        toggle.setAttribute("aria-expanded", "false");
        links.classList.remove("open");
      }
    });
  }

  /* ------------------------------------------- transparent nav over hero */
  var nav = document.querySelector(".nav");
  var darkHead = document.querySelector(".hero, .phead");

  if (nav && darkHead) {
    // Transparent while resting at the top of a dark header, solid as soon as
    // the page moves — otherwise the nav floats over scrolling hero content
    // and the two collide.
    var setNavState = function () {
      var atRest = window.scrollY < 48;
      nav.classList.toggle("on-dark", atRest && !(links && links.classList.contains("open")));
    };
    setNavState();
    window.addEventListener("scroll", setNavState, { passive: true });
    window.addEventListener("resize", setNavState);
    if (toggle) toggle.addEventListener("click", function () { setTimeout(setNavState, 0); });
  }

  /* ------------------------------------------------------ reveal on scroll */
  var revealables = document.querySelectorAll(".rv");
  if (revealables.length) {
    if (!("IntersectionObserver" in window)) {
      revealables.forEach(function (el) { el.classList.add("in"); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
      revealables.forEach(function (el) { io.observe(el); });
    }
  }

  /* ------------------------------------------------- hero leader lines */
  // Each hero label names a specific part of the implant. The line is drawn
  // from the label to a point given as a fraction of the implant image
  // (data-tx / data-ty), so it keeps aiming at the right part as the image
  // scales. Purely decorative — the labels read fine without it.
  var leadSvg = document.querySelector(".hero-leads");
  var heroArt = document.querySelector(".hero-figure img");

  if (leadSvg && heroArt) {
    var NS = "http://www.w3.org/2000/svg";
    var labels = Array.prototype.slice.call(document.querySelectorAll(".callout[data-tx]"));

    var drawHeroLeaders = function () {
      var figure = leadSvg.parentElement;
      var fr = figure.getBoundingClientRect();
      var ir = heroArt.getBoundingClientRect();
      if (!fr.width || !ir.width) return;

      leadSvg.setAttribute("viewBox", "0 0 " + fr.width + " " + fr.height);
      while (leadSvg.firstChild) leadSvg.removeChild(leadSvg.firstChild);

      // labels are hidden by CSS on narrow viewports — nothing to point with
      if (getComputedStyle(labels[0]).display === "none") return;

      labels.forEach(function (el) {
        var lr = el.getBoundingClientRect();
        var pointsLeft = el.classList.contains("right");

        // start just outside the label, on the side facing the implant
        var x1 = (pointsLeft ? lr.left - 10 : lr.right + 10) - fr.left;
        var y1 = lr.top + lr.height / 2 - fr.top;

        // end on the named part of the implant
        var x2 = ir.left + ir.width * parseFloat(el.dataset.tx) - fr.left;
        var y2 = ir.top + ir.height * parseFloat(el.dataset.ty) - fr.top;

        var line = document.createElementNS(NS, "line");
        line.setAttribute("x1", x1); line.setAttribute("y1", y1);
        line.setAttribute("x2", x2); line.setAttribute("y2", y2);
        leadSvg.appendChild(line);

        var dot = document.createElementNS(NS, "circle");
        dot.setAttribute("cx", x2); dot.setAttribute("cy", y2); dot.setAttribute("r", 2.5);
        leadSvg.appendChild(dot);
      });
    };

    if (heroArt.complete) drawHeroLeaders();
    else heroArt.addEventListener("load", drawHeroLeaders);
    window.addEventListener("resize", drawHeroLeaders);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(drawHeroLeaders);
  }

  /* ------------------------------------------------------- contact form */
  // Submissions are POSTed to the provider configured as FORM_ENDPOINT in
  // build.py, which delivers them to info@biodentinc.com. With no endpoint
  // configured the form degrades to a mail-client handoff to the same address
  // rather than silently dropping the enquiry.
  var form = document.getElementById("inquiry-form");

  if (form) {
    var status = document.getElementById("form-status");
    var submitBtn = form.querySelector('[type="submit"]');
    var btnLabel = submitBtn && submitBtn.querySelector(".btn-label");
    var fallbackEmail = form.getAttribute("data-fallback-email") || "info@biodentinc.com";

    var say = function (msg, kind) {
      if (!status) return;
      status.textContent = msg;
      status.className = "form-status is-" + kind;
      status.hidden = false;
    };

    // human-readable "Label: value" lines, used for the mailto fallback
    var asLines = function (data) {
      var lines = [];
      form.querySelectorAll("[name]").forEach(function (el) {
        if (el.type === "hidden" || el.name.charAt(0) === "_") return;
        var wrap = el.closest(".field");
        var label = wrap && wrap.querySelector("span");
        var name = label ? label.textContent.replace(/\s*\*\s*$/, "").trim() : el.name;
        var val = (data.get(el.name) || "").toString().trim();
        if (val) lines.push(name + ": " + val);
      });
      return lines;
    };

    var mailtoFallback = function (data) {
      var subject = "Ultratooth enquiry — " + (data.get("practice") || data.get("name") || "Website");
      window.location.href =
        "mailto:" + fallbackEmail +
        "?subject=" + encodeURIComponent(subject) +
        "&body=" + encodeURIComponent(asLines(data).join("\n"));
      say("Your email application should now be open with the details filled in. " +
          "If nothing happened, email " + fallbackEmail + " directly.", "info");
    };

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      // native validation first, so required fields behave normally
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var data = new FormData(form);

      // honeypot — a bot filled a field no human can see
      if ((data.get("_honey") || "").toString().trim() !== "") return;

      // let the provider reply straight to the sender
      var replyto = form.querySelector('[name="_replyto"]');
      if (replyto) { replyto.value = data.get("email") || ""; data.set("_replyto", replyto.value); }

      var endpoint = form.getAttribute("action");
      if (!endpoint) { mailtoFallback(data); return; }

      if (submitBtn) submitBtn.disabled = true;
      if (btnLabel) btnLabel.textContent = "Sending…";
      say("Sending your enquiry…", "info");

      fetch(endpoint, { method: "POST", body: data, headers: { Accept: "application/json" } })
        .then(function (res) {
          if (!res.ok) throw new Error("HTTP " + res.status);
          form.reset();
          say("Thank you — your enquiry has been sent to " + fallbackEmail +
              ". We'll come back to you shortly.", "ok");
        })
        .catch(function () {
          say("Sorry — that didn't send. Please email " + fallbackEmail +
              " directly, or call (747) 800-8011.", "err");
        })
        .then(function () {
          if (submitBtn) submitBtn.disabled = false;
          if (btnLabel) btnLabel.textContent = "Send enquiry";
        });
    });
  }
})();
